// @ts-nocheck
import { Column } from 'react-table'
import { OrderInfoCell } from './OrderInfoCell'
import { OrderActionsCell } from './OrderActionsCell'
import { OrderSelectionCell } from './OrderSelectionCell'
import { OrderCustomHeader } from './OrderCustomHeader'
import { OrderSelectionHeader } from './OrderSelectionHeader'
import { Order } from '../../core/_models'
import { FormattedMessage } from 'react-intl'
import dayjs from 'dayjs'
import toast from 'react-hot-toast'

const ordersColumns: ReadonlyArray<Column<Order>> = [
  {
    Header: (props) => (
      <OrderCustomHeader
        tableProps={props}
        title={<FormattedMessage id='TABLE.GENERAL.ACTION' />}
        className='text-end min-w-80px' // Reduced width
      />
    ),
    id: 'actions',
    Cell: ({ row }) => {
      const copyAllData = () => {
        const rechargeableAccount = row.original.rechargeble_account || 'N/A';
        const title = row.original.bundle?.bundle_title || 'N/A';
        const companyName = row.original.bundle?.service?.company?.company_name || 'N/A';

        const clipboardData = `
          شماره حساب: ${rechargeableAccount}
          بسته: ${title}
          شرکت: ${companyName}
        `.trim();

        navigator.clipboard.writeText(clipboardData);
        toast.success('کاپی شد');
      };

      return (
        <div className="d-flex justify-content-end align-items-center">
          <OrderActionsCell
            id={row.original.id}
            order={row.original}
          />
          <button
            onClick={copyAllData}
            className="btn btn-icon btn-sm btn-light-success ms-2"
            title="Copy all data"
          >
            <i className="fa fa-copy"></i>
          </button>
        </div>
      );
    },
  },
  {
    Header: (props) => (
      <OrderCustomHeader
        tableProps={props}
        title={<FormattedMessage id='ORDER.TABLE.COLUMN.STATUS' />}
        className='min-w-80px' // Reduced width
      />
    ),
    accessor: 'status',
    Cell: ({ value }) => {
      const renderStatusBadge = () => {
        if (value == 1) {
          return <span className="badge badge-success">Confirmed Order</span>;
        } else if (value == 0) {
          return <span className="badge badge-danger">Pending Order</span>;
        } else if (value == 3) {
          return <span className="badge badge-info">Under Process</span>;
        } else if (value == 2) {
          return <span className="badge badge-danger">Rejected Order</span>;
        }
        return null; // Handle other cases or return nothing
      };

      return renderStatusBadge();
    },
  },
  {
    Header: (props) => <OrderSelectionHeader tableProps={props} />,
    id: 'selection',
    className: 'min-w-40px', // Narrower width for selection
    Cell: ({ ...props }) => <OrderSelectionCell id={props.data[props.row.index].id} />,
  },
  {
    Header: (props) => (
      <OrderCustomHeader
        tableProps={props}
        title={<FormattedMessage id='ORDER.TABLE.COLUMN.RESELLERNAME' />}
        className='min-w-120px' // Reduced width
      />
    ),
    accessor: 'reseller.reseller_name',
    Cell: ({ ...props }) => <OrderInfoCell order={props.data[props.row.index]} />,
  },
  {
    Header: (props) => (
      <OrderCustomHeader
        tableProps={props}
        title={<FormattedMessage id='ORDER.TABLE.COLUMN.RECHARGEABLEACCOUNT' />}
        className='min-w-80px' // Reduced width
      />
    ),
    accessor: 'rechargeble_account',
    Cell: ({ value }) => {
      const copyRechargeableAccount = () => {
        if (value) {
          navigator.clipboard.writeText(value);
          toast.success('کاپی شد');
        } else {
          toast.error('No rechargeable account to copy.');
        }
      };

      return (
        <div className="d-flex align-items-center">
          <button
            onClick={copyRechargeableAccount}
            className="btn btn-icon btn-sm btn-light-primary"
            title="Copy rechargeable account"
          >
            <i className="fa fa-copy"></i>
          </button>
          <span className="me-2">{value}</span>
        </div>
      );
    },
  },
  {
    Header: (props) => (
      <OrderCustomHeader
        tableProps={props}
        title={<FormattedMessage id='ORDER.TABLE.COLUMN.BUNDLEID' />}
        className='min-w-60px' // Reduced width
      />
    ),
    accessor: 'bundle.id',
  },
  {
    Header: (props) => (
      <OrderCustomHeader
        tableProps={props}
        title={<FormattedMessage id='ORDER.TABLE.COLUMN.PAYABLEAMOUNT' />}
        className='min-w-80px' // Reduced width
      />
    ),
    accessor: 'bundle.buying_price',
  },
  {
    Header: (props) => (
      <OrderCustomHeader
        tableProps={props}
        title={<FormattedMessage id='ORDER.TABLE.COLUMN.DISCOUNTEDPRICE' defaultMessage={"قیمت بعد از تخفیف"} />}
        className='min-w-80px' // Reduced width
      />
    ),
    accessor: 'bundle.discounted_price',
  },
  {
    Header: (props) => (
      <OrderCustomHeader
        tableProps={props}
        title={<FormattedMessage id='ORDER.TABLE.COLUMN.PROFIT' defaultMessage={"مفاد خالص"} />}
        className='min-w-80px' // Reduced width
      />
    ),
    id: 'profit_margin',
    accessor: (row) => ((row.bundle.discounted_price -row.bundle.admin_buying_price)),
    Cell: ({ value }) => <span>{value?.toFixed(2)}</span>,
  },
  {
    Header: (props) => (
      <OrderCustomHeader
        tableProps={props}
        title={<FormattedMessage id='ORDER.TABLE.COLUMN.BUNDLETITLE' />}
        className='min-w-80px' // Reduced width
      />
    ),
    accessor: 'bundle.bundle_title',
  },
  {
    Header: (props) => (
      <OrderCustomHeader
        tableProps={props}
        title={<FormattedMessage id='ORDER.TABLE.COLUMN.BUNDLEDESCRIPTION' />}
        className='min-w-100px' // Reduced width
      />
    ),
    accessor: 'bundle.bundle_description',
  },
  {
    Header: (props) => (
      <OrderCustomHeader
        tableProps={props}
        title={<FormattedMessage id='ORDER.TABLE.COLUMN.REJECTREASON' />}
        className='min-w-80px' // Reduced width
      />
    ),
    accessor: 'reject_reason',
  },
  {
    Header: (props) => (
      <OrderCustomHeader
        tableProps={props}
        title={<FormattedMessage id='ORDER.TABLE.COLUMN.COMPANYNAME' />}
        className='min-w-80px' // Reduced width
      />
    ),
    accessor: 'bundle.service.company.company_name',
  },
  {
    Header: (props) => (
      <OrderCustomHeader
        tableProps={props}
        title={<FormattedMessage id='ORDER.TABLE.COLUMN.CATEGORYNAME' />}
        className='min-w-80px' // Reduced width
      />
    ),
    accessor: 'bundle.service.service_category.category_name',
  },
  {
    Header: (props) => (
      <OrderCustomHeader
        tableProps={props}
        title={<FormattedMessage id='ORDER.TABLE.COLUMN.ORDEREDDATE' />}
        className='min-w-100px' // Adjusted width for date
      />
    ),
    accessor: 'created_at',
    Cell: ({ value }) => (
      <span>{dayjs(value).format('MMMM DD, YYYY HH:mm:ss')}</span>
    ),
  },

  {
    Header: (props) => (
      <OrderCustomHeader
        tableProps={props}
        title={<FormattedMessage id='PAYMENT.TABLE.COLUMN.PERFORMEDBY' defaultMessage='انجام دهنده' />}
        className='min-w-100px'
      />
    ),
    id: 'performed_by_name',
    accessor: 'performed_by_name',
  },
];

export { ordersColumns };
